import React from 'react';
import './_changeLog.scss';
import { useNavigate } from 'react-router-dom';
import RightArrow from '../../Icons/icons/RightArrow';

const TakeMeThere = ({ navigateTo, onClose }) => {
  const navigate = useNavigate();

  const navigateAfterClose = () => {
    onClose();
    navigate(navigateTo);
  };

  if (!Boolean(navigateTo?.length)) {
    return <></>;
  }

  return (
    <div onClick={navigateAfterClose} className="change-log-navigate-container">
      Check it out
      <RightArrow />
    </div>
  );
};

export default TakeMeThere;
